export { useGlobalStore } from './global';
